import React, { useReducer } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Icon } from '@material-ui/core';
import { logout as logoutAction } from '../actions/auth';
import { environment } from '../common/util';
import AccordionItem from './AccordionItem';

const Navbar = ({ auth, logout }) => {
  const [accordionStates, setAccordionStates] = useReducer(
    (state, action) => ({ ...state, ...action }),
    {
      snapstyr: false,
    },
  );

  const toggleAccordion = (accordionKey) => (event, isExpanded) => {
    setAccordionStates({
      [accordionKey]: isExpanded,
    });
  };

  const adminMenuItems = [
    { link: '/admin/analytics', icon: 'trending_up', label: 'Analytics', roles: ['Manager'], ac: 'analyticsRead'  },
    // Monstyr page will be id == 19
    { link: '/admin/page/19', icon: 'category', label: 'Monstyr Page', roles: ['Manager'], ac: 'pageRead'  },
    { link: '/admin/page', icon: 'store_mall_directory', label: 'Pages', roles: ['Manager'], ac: 'pageRead' },
    { link: '/admin/posts', icon: 'description', label: 'Posts', roles: ['Manager'], ac: 'postRead' },
    {
      type:         'accordion',
      icon:         'room',
      label:        'Snapstyr',
      roles:        ['Manager'],
      ac:           'poiRead',
      accordionKey: 'snapstyr', // Unique key for this accordion
      subItems:     [
        { link: '/admin/pois',  label: 'POIs', roles: ['Manager'], ac: 'poiRead' },
        { link: '/admin/photos', label: 'Photos', roles: ['Manager'], ac: 'poiRead' },
        { link: '/admin/comments', label: 'Comments', roles: ['Manager'], ac: 'commentRead' },
        { link: '/admin/contriPois', label: 'Public Contributed POIs', roles: ['Manager'], ac: 'poiRead' },
        { link: '/admin/snapstyr-favs', label: 'Snapstyr Favs', roles: ['Manager'], ac: 'pinnedPhotoRead' },
      ],
    },
    { link: '/admin/reviews', icon: 'description', label: 'Reviews', roles: ['Manager'], ac: 'reviewRead' },
    { link: '/admin/freeAds', icon: 'padding', label: 'Free Ads', roles: ['Manager'], ac: 'quickAdRead' },
    { link: '/admin/address', icon: 'room', label: 'Address', roles: ['Manager'], ac: 'addressRead' },
    { link: '/admin/area', icon: 'room', label: 'Area', roles: ['Manager'], ac: 'areaRead' },
    { link: '/admin/mallMaps', icon: 'map', label: 'Mall Maps', roles: ['Manager'], ac: 'pageRead' },
    { link: '/admin/category', icon: 'category', label: 'Category', roles: ['Manager'], ac: 'categoryRead'  },
    { link: '/admin/categoryPinnedPost/All', icon: 'push_pin', label: 'Category Pinned Post', roles: ['Manager'], ac: 'mobileAppRead'  },
    { link: '/admin/scrappedPromos', icon: 'contactless', label: 'Scrapped Posts', roles: ['Manager'], ac: 'scrappedPromoRead' },
    { link: '/admin/receiptUploads', icon: 'contactless', label: 'Receipt Uploads', roles: ['Manager'], ac: 'loyaltyCardRead' },
    { link: '/admin/uploadScrappedPromo', icon: 'contactless', label: 'Upload Scrapped Post', roles: ['Manager'], ac: 'scrappedPromoAdd' },
    { link: '/admin/highlights', icon: 'star', label: 'Highlights', roles: ['Manager'], ac: 'highlightsRead'  },
    { link: '/admin/advertisement', icon: 'trending_up', label: 'Advertisement', roles: ['Manager'], ac: 'adRead'   },
    { link: '/admin/tags', icon: 'style', label: 'Tags', roles: ['Manager'], ac: 'tagRead'  },
    { link: '/admin/status', icon: 'donut_large', label: 'System Status', roles: ['Manager'], ac: 'mobileAppRead'  },
    { link: '/admin/mobileApp', icon: 'style', label: 'Mobile/Web App Tools', roles: ['Manager'], ac: 'mobileAppRead'  },
    { link: '/admin/user-moderation', icon: 'gavel', label: 'User Moderation', roles: ['Manager'], ac: 'userModerationRead'  },
    { link: '/admin/staff', icon: 'supervisor_account_icon', label: 'Staff', roles: ['Manager'], ac: 'staffRead'  },
    { link: '/admin/business', icon: 'store_mall_directory', label: 'Business', roles: ['Manager'], ac: 'businessRead'  },
    // {
    //     link: "/admin/unapproved-promo",
    //     icon: "check_circle_outline",
    //     label: "Unapproved Promo",
    //     roles: ['Manager']
    // },
    // { link: "/admin/mall", icon: "local_mall", label: "Mall", roles:[] },
    // { link: "/admin/store", icon: "store_mall_directory", label: "Store", roles: []  },
    //,{
    //   link: "/admin/article-writing",
    //   icon: "trending_up",
    //   label: "Article Writing",
    //   roles: ['Manager']
    // },{
    //   link: "/admin/article-writing",
    //   icon: "trending_up",
    //   label: "Staff Mgmt",
    //   roles: ['Manager']
    // },
  ];

  const pagesMenuItems = [
    {
      link:  '/admin/page',
      icon:  'store',
      label: 'View All',
      roles: ['Manager'],
    }, {
      link:  '/admin/page',
      icon:  'info',
      label: 'Settings',
      roles: ['Manager'],
    },
  ];

  const pageMenuItems = [
    {
      link:  '/admin/page',
      icon:  'trending_up',
      label: '<page name>',
      roles: ['Manager'],
    },
    {
      link:  '/admin/advertisement',
      icon:  'businesses',
      label: 'Outlets',
      roles: ['Manager'],
    },
    {
      link:  '/admin/article-writing',
      icon:  'stars',
      label: 'Promotions',
      roles: ['Manager'],
    },
    {
      link:  '/admin/advertisement',
      icon:  'trending_up',
      label: 'Ads',
      roles: ['Manager'],
    },
    {
      link:  '/admin/advertisement',
      icon:  'trending_up',
      label: 'Analytics',
      roles: ['Manager'],
    },
  ];

  const navItem = (item) => (
    <li key={item.label}>
      <NavLink to={item.link}>
        <Icon>{item.icon}</Icon>
        <span>{item.label}</span>
      </NavLink>
    </li>
  );

  // Helper to render menu items
  const renderMenuItem = (item) => {
    const display = auth && auth.user && auth.user.acl && auth.user.acl.includes(item.ac);

    if (!display) return null;

    if (item.type === 'accordion') {
      return (
        <AccordionItem
          key={item.label}
          item={item}
          isExpanded={accordionStates[item.accordionKey] || false}
          onToggle={toggleAccordion(item.accordionKey)}
          auth={auth}
          subItems={item.subItems}
        />
      );
    }

    return navItem(item);
  };

  return (
    <nav>
      <>
        {auth.isAuthenticated ? (
          <ul>
            <li key="Monstyr">
              <h2 style={{ color: '#fff', paddingLeft: 25, paddingBottom: 8, borderColor: '#888', borderBottomStyle: 'solid', borderBottomWidth: 0.5 }}>
                Monstyr
                <span style={{
                  background:   (environment() === 'LOCAL' ? '#2980b9' : (environment() === 'PROD') ? '#8e44ad' : '#e67e22'),
                  position:     'relative',
                  margin:       '10px 5px',
                  top:          '-9px',
                  padding:      '5px 10px',
                  fontSize:     10,
                  borderRadius: 10,
                }}
                >
                  {environment()}
                </span>
              </h2>
            </li>
            {adminMenuItems.map(renderMenuItem)}
            <li key="logout">
              <NavLink to="/admin/login" onClick={() => { logout(); console.log('logout clicked'); }}>
                <Icon>logout</Icon>
                <span>Logout</span>
              </NavLink>
              {/* <Button onClick={logout}>Logout</Button> */}
            </li>
          </ul>
        ) : ('')}
      </>
    </nav>
  );
};

Navbar.propTypes = {
  auth:   PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { logout: logoutAction })(Navbar);
